import Vue from 'vue'

import VueGtm from 'vue-tag-manager'

if (process.env.GTM_ID) {
  Vue.use(VueGtm, {
    gtmId: process.env.GTM_ID
  })
}
